import { Injectable, inject } from "@angular/core";
import { DefaultTreeviewI18n, TreeviewSelection } from "@soy-andrey-semyonov/ngx-treeview";
import { LanguageServices } from "src/app/services/LanguageServices";

@Injectable()
export class SimpleDataTreeviewI18n extends DefaultTreeviewI18n{

  translate = inject(LanguageServices);

  getText(selection: TreeviewSelection): string {
    
    
    if (selection.uncheckedItems.length === 0) {
      return this.translate.instant('tree.todaslinhas');
    }


    switch (selection.checkedItems.length) {
      case 0:
        return this.translate.instant('tree.selecionarlinha');
      case 1:
        return selection.checkedItems[0].text;
      default:
        return '${selection.checkedItems.length} '+ this.translate.instant('tree.linhasselecionadas');
    }
  }

  getFilterNoItemsFoundText(): string {
    return this.translate.instant('tree.noline');
  }

  getAllCheckboxText(): string{
      return this.translate.instant('tree.todos');
  }

  getFilterPlaceholder(): string{
      return this.translate.instant('tree.filtro');
  }
  
  getTooltipCollapseExpandText(isCollapse: boolean): string{
      if ( isCollapse){
          return this.translate.instant('tree.expandir');
      }else{
          return this.translate.instant('tree.encolher');
      }
  }
}